import React, { useEffect, useState } from 'react'
import { Spin } from 'antd';
import { getLayerImageByName } from 'assets/imgs/imageIndex';
import LayerMenuCategory from './components/LayerMenuCategory';
import SearchResults from './components/SearchResults';
import LayerSearchBar from './components/LayerSearchBar';
import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';
import homeService from 'services/homeService';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import useActiveLayersStore from 'stores/useSelectedLayersStore';


const MapLeftBar = ({
    mapRef, updateLayer, showLayer, hideLayer
}) => {

    //  localStorage.clear();
    const menuItems = LayersAndResolutions.layers.map(layer => ({
        key: layer.longName, productName: layer.productName, description: layer.description, iconUrl: getLayerImageByName(layer.shortName)
    }));

    const [filteredMenuItems, setFilteredMenuItems] = useState(menuItems);
    const [searchTerm, setSearchTerm] = useState(''); // The term you're searching for.
    const [searchActive, setSearchActive] = useState(false);
    const [isLayerMenuVisible, setIsLayerMenuVisible] = useState(true);
    const [collapsedCategories, setCollapsedCategories] = useState({
        meteorologicalLayers: false,
        eumetsatLayers: false
    });

    const spatialResArray = useActiveLayersStore((state) => state.spatialResArray);
    const temporalResArray = useActiveLayersStore((state) => state.temporalResArray);
    const selectedLayers = useActiveLayersStore((state) => state.selectedLayers);

    const updateTemporalResArray = useActiveLayersStore((state) => state.updateTemporalResArray);
    const updateSpatialResArray = useActiveLayersStore((state) => state.updateSpatialResArray);
    const searchSelectedLayerIndex = useActiveLayersStore((state) => state.searchSelectedLayerIndex);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchDates = async () => {
            try {
                await homeService.getCommonDatesDefault();
            } catch (error) {
                console.error('Failed to fetch default common dates:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDates();
    }, []);

    function checkButtonSelected(layer, resType, resolutionSelected) {
        const index = selectedLayers.indexOf(layer);

        switch (resType) {
            case 'space': return spatialResArray[index] === resolutionSelected;
            case 'time': return temporalResArray[index] === resolutionSelected;
            default: return false;
        }
    }

    const handleCheckboxClick = async (layer) => {

        if (selectedLayers.includes(layer)) {
            await hideLayer(layer);
        } else {
            await showLayer(layer);
        }

    }

    const toggleLayerMenuVisibility = () => {
        setIsLayerMenuVisible(!isLayerMenuVisible);
        mapRef.current.invalidateSize(); // Makes Leaflet charge the 'empty' tiles. 
    };

    const handleSearch = (e) => {
        const input = e.target.value;
        const value = input.toLowerCase();
        setSearchTerm(input);

        if (value === '') {
            setSearchActive(false);
            setFilteredMenuItems(menuItems);
        } else {
            setSearchActive(true);
            // Filter items by key or description
            const filtered = menuItems.filter(item =>
                item.key.toLowerCase().includes(value) ||
                item.productName.toLowerCase().includes(value)
            );
            setFilteredMenuItems(filtered);
        }
    };

    const toggleCategory = (category, e) => {
        e.stopPropagation();
        setCollapsedCategories(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    const handleChangeResolution = (layer, resType, resolutionSelected) => {
        switch (resType) {
            case 'space': {
                const index = searchSelectedLayerIndex(layer);
                updateSpatialResArray(layer, resolutionSelected);
                updateLayer(layer, index);
                break;
            }
            case 'time': {
                const index = searchSelectedLayerIndex(layer);
                updateTemporalResArray(layer, resolutionSelected);
                updateLayer(layer, index);
                break;
            }
            default: return;
        }
    };

    const isLayerSelected = (layer) => {
        return selectedLayers.includes(layer);
    }

    return (
    
        <div style={{ position: 'relative' }}>
            <div
                className={`windy-style-menu ${isLayerMenuVisible ? '' : 'collapsed'}`}
                style={{
                    pointerEvents: isLoading ? 'none' : 'auto',
                    opacity: isLoading ? 0.5 : 1,
                }}
            >
                <div id="windy-style-header">
                    <LayerSearchBar
                        onClear={() => {
                            setSearchTerm('');
                            setSearchActive(false);
                            setFilteredMenuItems(menuItems);
                        }}
                        searchTerm={searchTerm}
                        handleSearch={handleSearch}
                    />
                </div>

                <div className="windy-style-layer-list">
                    {searchActive ? (
                        <SearchResults
                            filteredMenuItems={filteredMenuItems}
                            selectedLayers={selectedLayers}
                            checkButtonSelected={checkButtonSelected}
                            handleChangeResolution={handleChangeResolution}
                            showLayer={showLayer}
                            handleCheckboxClick={handleCheckboxClick}
                            isLayerSelected={isLayerSelected}
                        />
                    ) : (
                        <>
                            <LayerMenuCategory
                                title="Clim4Cast monitoring and forecasting tool layers"
                                isCollapsed={collapsedCategories.meteorologicalLayers}
                                toggleCategory={toggleCategory}
                                categoryKey="meteorologicalLayers"
                                items={menuItems.slice(0, 7)}
                                handleChangeResolution={handleChangeResolution}
                                handleCheckboxClick={handleCheckboxClick}
                                checkButtonSelected={checkButtonSelected}
                                notification={notification}
                                showLayer={showLayer}
                                isLayerSelected={isLayerSelected}
                            />

                            <LayerMenuCategory
                                title="EUMETSAT LSA SAF"
                                isCollapsed={collapsedCategories.eumetsatLayers}
                                toggleCategory={toggleCategory}
                                categoryKey="eumetsatLayers"
                                items={menuItems.slice(7, 11)}
                                handleChangeResolution={handleChangeResolution}
                                handleCheckboxClick={handleCheckboxClick}
                                checkButtonSelected={checkButtonSelected}
                                notification={notification}
                                showLayer={showLayer}
                                isLayerSelected={isLayerSelected}
                            />
                        </>
                    )}
                </div>

                <button
                    className={`windy-style-toggle-btn ${!isLayerMenuVisible ? 'collapsed' : ''}`}
                    onClick={toggleLayerMenuVisibility}
                >
                    {isLayerMenuVisible ? <LeftOutlined /> : <RightOutlined />}
                </button>
            </div>

            {isLoading && (
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    zIndex: 999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'auto'
                }}>
                    <Spin size="large" />
                </div>
            )}
        </div>
);

}

export default MapLeftBar;